'use client';

import type React from 'react';
import { Input } from '@yaradigitallabs/ahua-react';

type TimeFilterProps = {
  selectedTime: string;
  onTimeChange: (value: string) => void;
  label: string;
  size?: 'xs' | 's' | 'n' | 'l';
  disabled?: boolean;
};

const TimeFilter: React.FC<TimeFilterProps> = ({
  selectedTime,
  onTimeChange,
  label = 'Select Time',
  size = 'n',
  disabled = false,
}) => {
  return (
    <Input
      css={{
        width: '100%',
        ...(disabled ? { backgroundColor: '#f3f4f6' } : {}),
      }}
      label={label}
      type="time"
      id={`time-filter-${label.toLowerCase().replace(/\s+/g, '-')}`}
      name={`time-filter-${label.toLowerCase().replace(/\s+/g, '-')}`}
      size={size}
      value={selectedTime}
      readOnly={disabled}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onTimeChange(e.target.value)
      }
    />
  );
};

export default TimeFilter;
